import RiveBadge, { BadgeType } from 'components/common/RiveBadge';

import styles from './RemixBadge.module.css';

export default function RemixBadge() {
  return (
    <div className={styles.Container}>
      <RiveBadge type={BadgeType.Standard}>Remix</RiveBadge>
    </div>
  );
}
